// extracted by mini-css-extract-plugin
module.exports = {"link":"Navigation_link__fJRws","active":"Navigation_active__iWhq5","widthIn":"Navigation_widthIn__TVn6I"};